export function snapshotEffect() {
	const el = document.createElement('div');

	el.style.position = 'fixed';
	el.style.width = '100vw';
	el.style.height = '100vh';
	el.style.background = 'white';
	el.style.left = '0px';
	el.style.top = '0px';

	document.body.appendChild(el);

	el.style.animation = 'snapshot 0.6s ease both';

	setTimeout(() => {
		el.remove();
	}, 600);
}
